import type { RequestTransformFunction } from "maplibre-gl";
import { useAuth } from "./auth";
import { redirect } from "react-router";
import { ApiError, reportApiError } from "./apiError";
import { getUrl } from "../getUrl";

export async function getWithHeaders<T>(
  url: string,
): Promise<{ data: T; headers: Headers }> {
  const token = await useAuth.getState().getToken();
  if (!token) {
    throw redirect("/login");
  }
  const response = await fetch(getUrl(url), {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (response.status === 401) {
    throw redirect("/login");
  }

  if (!response.ok) {
    const error = new ApiError("GET", url, response.status);
    reportApiError(error, error.logContext);
    throw error;
  }

  const data =
    response.headers.get("Content-Type") === "application/geo+json"
      ? JSON.parse(await response.text())
      : await response.json();

  return { data, headers: response.headers };
}

export async function get<T>(url: string): Promise<T> {
  const { data } = await getWithHeaders<T>(url);
  return data;
}

export async function getImage(url: string) {
  const token = await useAuth.getState().getToken();
  const response = await fetch(getUrl(url), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return URL.createObjectURL(await response.blob());
}

export const mapTransformRequest: RequestTransformFunction = (url) => {
  const { origin, pathname } = new URL(url);
  const token = useAuth.getState().accessToken;

  if (origin.endsWith(".aureaimaging.com") && pathname.startsWith("/v1")) {
    return {
      url,
      headers: { Authorization: `Bearer ${token}` },
    };
  }
};
